import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UrlConstants } from 'src/app/models/urlConstants';
import { IPO, IpoDocuments } from 'src/app/models/IPO';
import { ApiService } from 'src/app/services/api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { IpoAccOrderModalComponent } from 'src/app/components/ipo-acc-order-modal/ipo-acc-order-modal.component';
import { NumberFormatPipe } from "../../pipes/number-format.pipe";
import { forkJoin } from 'rxjs';
import { SystemSettingsService } from 'src/app/services/systemSettings.service';
import { Router } from '@angular/router';
//Needs refactoring
@Component({
  selector: 'app-ipo',
  templateUrl: './ipo.component.html',
  styleUrls: ['./ipo.component.scss'],
})
export class IPOComponent implements OnInit {

  lang: string;
  numberOfAccounts: number=2;
  isDarkTheme: boolean;
  events: any[] = [
    { title: 'Event 1', description: 'Description for event 1', date: new Date('2020-01-01') },
    { title: 'Event 2', description: 'Description for event 2', date: new Date('2020-02-01') },
    // Add more events here
  ];
  isEGID = UrlConstants.isEGID;
  ipoList : IPO[] = [];
  selectedIPO: IPO;
  lastSelectedIpoIndex = -1;
  ipoDocuments: IpoDocuments;
  dialog: any;
  ipoAllotmentRatio : string;
  IPOTotalVolume: any;
  coverageNumber: string;
  isRefreshing:boolean=false;
  ipoId:any;
  readonly ALLOW_IPO= "AllowIPO";

  constructor(
    public translate: TranslateService,
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
    private settingsService: SystemSettingsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.lang = this.translate.currentLang;
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;
      this.GetAvailableIposList();
      this.settingsService.checkSetting(this.ALLOW_IPO).subscribe(isAllowed => {
        if (!isAllowed) {
          this.router.navigate(["/"]);
        }
      }, error => {
      });
  
    }
  
  
    selectIPO(ipo: IPO, index: number){
      this.selectedIPO = ipo;
      if (this.lastSelectedIpoIndex !== index) {
        this.ipoList[index].selected = !this.ipoList[index].selected;
        if (this.lastSelectedIpoIndex !== -1) {
            this.ipoList[this.lastSelectedIpoIndex].selected = false;
        }
        this.lastSelectedIpoIndex = index;
        this.GetIpoDocuments(ipo.Id)
      }
    }
  
    GetIpoDocuments(id){
      this.apiService.GetIpoDocuments(id)
      .subscribe(
        (res)=>{
          this.ipoDocuments = res;
        }
      )
    }
  
    fundActionModal(isBuy:boolean) {
      this.dialog.open(IpoAccOrderModalComponent, {
        panelClass: "modal-width",
        data:{
          isBuy : isBuy,
          numberOfAccounts: this.numberOfAccounts
        }
      });
    }


    GetAvailableIposList()
  {

      this.apiService.GetAvailableIposList()
      .subscribe(
        (res) => {
          if(res){
            this.ipoList = res;
            
            this.selectedIPO = this.ipoList[0];
            this.GetIpoDocuments(this.selectedIPO.Id);
            this.ipoList[0].selected = !this.ipoList[0].selected;
            this.lastSelectedIpoIndex = 0; 
            const apiCalls = this.ipoList.map(ipo =>
              this.apiService.fetchIPOTotalVolume(ipo.SymbolCode)
            );
          
            forkJoin(apiCalls).subscribe((responses: number[]) => {
              this.ipoList = this.ipoList.map((ipo, index) => ({
                ...ipo,
                IPOTotalVolume: responses[index],
                ipoAllotmentRatio: ipo.PublicStake >= responses[index] 
                  ? 100                   
                  : (ipo.PublicStake / responses[index] ) * 100
              }));
            });
            
          } else {
            this.ipoList = null;
          }
        }
      );
    }

    CalculateIPOAllotmentRatio() {
      const apiCalls = this.ipoList.map(ipo =>
        this.apiService.fetchIPOTotalVolume(ipo.SymbolCode)
      );

      this.GetAvailableIposList();
    }
    fetchIPOTotalVolume(symbolCode: any): Promise<any> {
      return new Promise((resolve, reject) => {
        this.apiService.fetchIPOTotalVolume(symbolCode)
          .subscribe(
            (res) => {
              if (res) {

                resolve(this.ipoList.find((ipo)=>ipo.SymbolCode == symbolCode).IPOTotalVolume); // Resolve the promise with the response
              } else {
                this.IPOTotalVolume = null; // Handle empty response
                resolve(null); // Resolve the promise with null
              }
            },
            (error) => {
              this.IPOTotalVolume = null;
              reject(error); // Reject the promise with the error
            }
          );
      });
    }


    CalculateIPOCoverage(ipoDetail: any, ipoOrderValue: any, symbolCode: string): number {

      if (ipoDetail && ipoDetail.PublicStake && ipoOrderValue[1].__zone_symbol__value) {
        const ipoTotalOrderQty =ipoOrderValue[1].__zone_symbol__value;
        const publicStake = ipoDetail.PublicStake;
    
        if( (ipoTotalOrderQty / publicStake)>1){
        this.ipoList = this.ipoList.map(ipo =>
          ipo.SymbolCode === ipo.SymbolCode 
            ? { ...ipo, coverageRatio: (ipoTotalOrderQty / publicStake).toFixed(2)}                  
            : ipo
        );

        } 

      } 
      
      else {
        return null; // Handle the case where data is undefined
      }
    }
    refreshCLicked()
  {
    
    this.isRefreshing=true;
    const volumePromises = this.ipoList.map(ipo => this.fetchIPOTotalVolume(ipo.SymbolCode));
          
          // Wait for all volume fetches to complete
          Promise.all(volumePromises).then(() => {
            // Once all volumes are fetched, calculate allotment ratio for each IPO
            this.ipoList.forEach((ipo: IPO) => {
              ipo.Logo = this.sanitizer.bypassSecurityTrustUrl(`${ipo.Logo}`);
              ipo.Logo = ipo.Logo.changingThisBreaksApplicationSecurity;
              ipo.selected = false;
               this.CalculateIPOAllotmentRatio();

              
            });
            this.isRefreshing=false;
          }).catch(error => {
            this.isRefreshing=false;
          });
          
  }
}
